import WeddingsPage from './weddingsPage.component';

export default WeddingsPage;